<template>
    <sa-page-layout ref="SaplStruttureProvenienzaView" :btnRouterBackVisible="true" :data="jsonData" :showModalLoading="showModalLoading" :pathResource="pathResource">
        <template slot="table-body">
            <rsa-configurazione-struttura-provenienza-view-component ref="cmpRsaConfigurazioneStrutturaProvenienzaView"></rsa-configurazione-struttura-provenienza-view-component>
        </template>
    </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import RsaConfigurazioneStrutturaProvenienzaViewComponent from "../components/RsaConfigurazioneStrutturaProvenienzaViewComponent.vue";

export default {
    components: { SaPageLayout, RsaConfigurazioneStrutturaProvenienzaViewComponent },
    data() {
        return {
            showModalLoading: false,
            pathResource: "/rsastruttureprovenienza",
            id: null,
            jsonData: {},
        };
    },
    mounted: function () {
        let me = this;
        me.id = this.$route.params.id;
        me.loadData();
    },
    methods: {
        loadData() {
            let me = this;
            me.$refs.cmpRsaConfigurazioneStrutturaProvenienzaView.init();
        },

        onUpdateJsonData(data) {
            let me = this;
            me.jsonData = data;
        },
        onBeforeLoadData() {
            let me = this;
            me.showModalLoading = true;
        },
        onAfterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
    },
};
</script>

<style></style>
